export enum RiskMode {
  REPORT = 'REPORT',
  EVALUATION = 'EVALUATION',
}
